export { default } from './MenuSecundari';
